import useTimeout from "./useTimeout";
import {useEventListener} from "./useEventListener";
import useEffectOnce from "./useEffectOnce";


export function useLongPress(ref, cb, {delay = 600} = {}) {
    const {reset, clear} = useTimeout(cb, delay)
    useEffectOnce(clear)

    const instance = ref.current

    // useEventListener("mousedown", reset, instance)
    useEventListener("touchstart", reset, instance)

    // useEventListener("mouseup", clear, instance)
    // useEventListener("mouseleave", clear, instance)
    useEventListener("touchend", clear, instance)
    useEventListener("touchmove", clear, instance)
}
